import { useMutation } from "@tanstack/react-query";

import { updateUserSettings } from "@app/analytics/preferences/api";
import type { JobDepartment, JobRoleLevel } from "@app/analytics/types";

export interface FirmographicsFieldValues {
  jobTitle: string;
  jobDepartment: JobDepartment;
  jobRoleLevel: JobRoleLevel;
}

const useUpdateFirmographics = () => {
  return useMutation({
    mutationFn: (body: FirmographicsFieldValues) => updateUserSettings(body),
  });
};

export default useUpdateFirmographics;
